/**
 * Copy text to the clipboard without ever throwing.
 *
 * navigator.clipboard.writeText rejects in insecure/headless contexts or when
 * the permission is denied; an unhandled rejection surfaces React's runtime
 * error overlay. This helper swallows failures (with a legacy execCommand
 * fallback) and returns a boolean so callers can toast success/failure.
 */
export async function copyToClipboard(text) {
    try {
        if (navigator.clipboard && window.isSecureContext) {
            await navigator.clipboard.writeText(text);
            return true;
        }
    } catch (_) { /* fall through to legacy path */ }
    try {
        const ta = document.createElement('textarea');
        ta.value = text;
        ta.style.position = 'fixed';
        ta.style.opacity = '0';
        document.body.appendChild(ta);
        ta.focus();
        ta.select();
        const ok = document.execCommand('copy');
        document.body.removeChild(ta);
        return ok;
    } catch (_) {
        return false;
    }
}
